import React, { PureComponent } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Mail, MobileMail, BrandLogo, HowToBadge } from '../../atoms/Icons';
import { ProfileIcon } from '../../molecules/ProfileIcon';
import { HamburgerButton } from '../../atoms/HamburgerButton';
import { HamburgerContent } from '../../molecules/HamburgerContent';
import {
  Container,
  LeftContainer,
  LogoWrapper,
  RightContainer,
  AnchorWrapper,
  Anchor,
  AnchorUnderline,
  IconContainer,
  ProfileWrapper,
  HamburgerWrapper,
  MobileIconsContainer,
  DropdownContainer,
  NavBarWrapper,
  LeftWrapper,
  MobileMailIconContainer,
  HowToWrapper,
  HowToLabel,
} from './elements';
import { TopNavBarProps } from './types';
import { words } from '../../../constants';
import { paths, HOW_TO_USE_URL } from '../../../constants/routes/urls';

type Props = TopNavBarProps & Partial<DefaultProps> & RouteComponentProps;
type DefaultProps = Readonly<typeof defaultProps>;

const defaultProps = {
  isAuthenticated: false as boolean,
};

type State = {
  isHamburgerVisible: boolean;
  pageYOffset: number;
  pageChanged: boolean;
};

class TopNavBar extends PureComponent<
  Props & DefaultProps & RouteComponentProps,
  State
> {
  _window: Window;
  static defaultProps = defaultProps;

  constructor(props: Props & DefaultProps & RouteComponentProps) {
    super(props);

    this.state = {
      isHamburgerVisible: false,
      pageYOffset: 0,
      pageChanged: false,
    };

    this._window = window;
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentDidUpdate(prevProps: Props) {
    if (
      prevProps.location !== prevProps.history.location &&
      this.state.isHamburgerVisible
    ) {
      this.onToggleHamburger();
      this.setState(prevState => ({
        pageChanged: !prevState.pageChanged,
      }));
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    this.setState({ pageYOffset: this._window.pageYOffset });
  };

  onToggleHamburger = () => {
    this.setState(prevState => ({
      isHamburgerVisible: !prevState.isHamburgerVisible,
    }));
  };

  render = (): React.ReactElement => {
    const {
      homeLink,
      links,
      hasNotif,
      profileLabel,
      profileImgSrc,
      name,
      onPressHamburgerItem,
      isAuthenticated,
      history,
    } = this.props;
    const { isHamburgerVisible, pageYOffset, pageChanged } = this.state;

    return (
      <NavBarWrapper pageYOffset={pageYOffset}>
        <Container>
          <LeftWrapper>
            <LeftContainer>
              <LogoWrapper>
                <BrandLogo homeLink={homeLink} />
              </LogoWrapper>
            </LeftContainer>
            {isAuthenticated && (
              // this link is for temporary purpose only. change if needed
              <HowToWrapper href={HOW_TO_USE_URL} target="_blank">
                <HowToBadge />
                <HowToLabel>{words.howtoUseMypage}</HowToLabel>
              </HowToWrapper>
            )}
          </LeftWrapper>
          {isAuthenticated && (
            <>
              <RightContainer>
                <AnchorWrapper
                  data-cy="topNavBar-myPageTopButton"
                  to={{
                    pathname: links.myPageTopUrl,
                    state: { prevPath: history?.location.pathname },
                  }}>
                  <Anchor>{words.topNavBarLabels.myPageTopUrl}</Anchor>
                  <AnchorUnderline />
                </AnchorWrapper>
                <IconContainer to={paths.mailBox}>
                  <Mail id="home-mailIcon" hasNotif={hasNotif} />
                </IconContainer>
                <ProfileWrapper data-cy="myPage-profile">
                  <ProfileIcon
                    imageSource={profileImgSrc}
                    label={profileLabel}
                  />
                </ProfileWrapper>
              </RightContainer>
              <MobileIconsContainer>
                <MobileMailIconContainer to={paths.mailBox}>
                  <MobileMail />
                </MobileMailIconContainer>
                <HamburgerWrapper>
                  <HamburgerButton
                    onToggle={this.onToggleHamburger}
                    pageChanged={pageChanged}
                  />
                </HamburgerWrapper>
              </MobileIconsContainer>
            </>
          )}
        </Container>
        {isAuthenticated && (
          <DropdownContainer isVisible={isHamburgerVisible}>
            <HamburgerContent
              onPressHamburgerItem={onPressHamburgerItem}
              label={profileLabel}
              imageSource={profileImgSrc}
              name={name}
            />
          </DropdownContainer>
        )}
      </NavBarWrapper>
    );
  };
}

const TopNavBarWithRouter = withRouter(TopNavBar);
export default TopNavBarWithRouter;
